import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import {
    getActiveStore,
    getLoadingStatus,
    getReconnecting,
} from 'src/modules/Redux';
import { LoadingStatus, ReconnectingStatus } from 'src/modules/Redux/types';
import NoStoreFound from '../NoStoreFound';
import ReconnectingAlert from './components/ReconnectingAlert';
import ReconnectFailed from './components/ReconnectFailed';

import {
    getShowSettingsModal,
    setShowSettingsModal,
} from 'src/modules/Redux/slices/settings';
import { SettingsModal } from './components/SettingsModal';
import { LoadingIndicator } from 'src/ui/components';
import { Classic } from './classic';

// swap with ErrorScreen after moving to online ordering
const Message = ({ children }: { children: React.ReactNode }) => {
    return (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center p-10">
            {children}
        </div>
    );
};

function CustomerPickupScreen() {
    const store = useSelector(getActiveStore);
    const loadingStatus = useSelector(getLoadingStatus);
    const reconnecting = useSelector(getReconnecting);
    const isModalOpen = useSelector(getShowSettingsModal);
    const dispatch = useDispatch();

    const handleModalClose = () => {
        dispatch(setShowSettingsModal(false));
    };

    if (
        loadingStatus === LoadingStatus.Loading ||
        loadingStatus === LoadingStatus.Idle
    ) {
        return (
            <Message>
                <LoadingIndicator />
            </Message>
        );
    }

    if (isEmpty(store)) {
        return <NoStoreFound />;
    }

    // export declare enum OrderStatusConfiguration {
    //     ManualAcceptManualComplete = 0,
    //     AutoAcceptManualComplete = 1,
    //     ManualAcceptAutoComplete = 2,
    //     AutoAcceptAutoComplete = 3
    // }
    if (
        store.orderStatusConfiguration === 2 ||
        store.orderStatusConfiguration === 3
    ) {
        return (
            <Message>
                <p>
                    Customer Pickup Screen is not allowed for stores with{' '}
                    <b>Use Pickup Estimate to Mark Orders Ready.</b> Please turn
                    this setting off in your dashboard.
                </p>
            </Message>
        );
    }

    if (reconnecting === ReconnectingStatus.Failed) {
        return <ReconnectFailed />;
    }
    return (
        <>
            {/* Add small overlay to top right corner that shows "reconnecting" text  */}
            {reconnecting === ReconnectingStatus.Reconnecting && (
                <ReconnectingAlert />
            )}
            <Classic />
            <SettingsModal
                isOpen={isModalOpen}
                onRequestClose={handleModalClose}
            />
        </>
    );
}

export default CustomerPickupScreen;
